import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner";

type Variant = "primary" | "secondary" | "danger";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

const styles: Record<Variant, string> = {
  primary: "bg-accent text-white hover:brightness-110",
  secondary: "bg-card text-primary border border-border hover:border-secondary",
  danger: "bg-red-600 text-white hover:brightness-110",
};

export function Button({
  variant = "primary",
  loading = false,
  disabled,
  className = "",
  children,
  ...rest
}: Props) {
  const isDisabled = disabled || loading;
  return (
    <button
      {...rest}
      disabled={isDisabled}
      className={`
        inline-flex items-center justify-center gap-2
        rounded-xl px-5 py-3 font-mono text-sm tracking-wide
        transition-all duration-150
        disabled:opacity-50 disabled:cursor-not-allowed
        ${styles[variant]} ${className}
      `}
    >
      {loading && <Spinner size={16} />}
      <span>{children}</span>
    </button>
  );
}
